import { of as observableOf, Observable } from 'rxjs';

import { mergeMap, tap } from 'rxjs/operators';
// #TODO 30-04-2018_FG Terminer les interfaces

// Angular
import { Injectable } from '@angular/core';
import { Location } from '@angular/common';

// Afidium
import { HotelService } from 'libraries/hotel/services/hotel.service';
import { HelperService } from 'libraries/hotel/services/helper.service';
import { BreadcrumbService } from 'libraries/hotel/services/breadcrumb.service';

import { ITripPropertyQuote } from 'libraries/hotel/models/quote';
import { IHotel } from 'libraries/hotel/models/hotel';
import { ISearchOffersResponse, IProperties, IQuotes } from 'libraries/service/resources/hotel/ISearchResponse';
import { ITraveller } from 'libraries/service/resources/hotel/ISearchParameters';

@Injectable()
export class SearchService {
    constructor(
        private hotelService: HotelService,
        private location: Location,
        private breadcrumbService: BreadcrumbService,
        private helperService: HelperService
    ) {
    }

    public getHotelsFromExistingTripsKey(
        tripsKey: string,
        view = 'list'
    ): Observable<IHotel[]> {
        return this.hotelService
            .getHotelsListFromId(tripsKey)
            .pipe(
                tap((response: ISearchOffersResponse) => {
                    if (response) {
                        // Set currencies to global currencies object
                        this.hotelService.setCurrencies(response.currency);
                        // Set request to global request object
                        this.hotelService.setRequestToCache({
                            traveller: response.traveller as ITraveller,
                            nbrecord: 100,
                            language: 'FR',
                            segment: response.segment,
                            quantity: response.quantity,
                            isOnlyRefundable: response.isOnlyRefundable ?? false
                        });

                        // Set travellers distribution to global travellers object
                        this.hotelService.setTravellersDistribution({
                            segment: this.hotelService.getRequestFromCache().segment,
                            traveller: response.traveller
                        });
                    }
                }),
                // Format hotels data
                mergeMap((response: ISearchOffersResponse) => this.formatHotelsData(response, view)),);
    }

    public formatHotelsData(
        hotelsData: ISearchOffersResponse,
        view = 'list'
    ): Observable<IHotel[]> {
        if (!hotelsData || !hotelsData.hasOwnProperty('quote')) {
            return observableOf(null);
        }

        this.breadcrumbService.setItems({
            search: {
                router: '/iaqobohotel/search/' + hotelsData.key,
                params: {view}
            }
        });

        // Set key and view to url
        this.location.go('/iaqobohotel/search/' + hotelsData.key, `view=${view}`);

        const hotelsList: ITripPropertyQuote[] = this.formatHotelsList(
            hotelsData.key,
            hotelsData.property,
            hotelsData.quote
        );
        const tripProperyQuote: IHotel[] = this.helperService.objectToArray(hotelsList);

        return observableOf(tripProperyQuote);
    }

    public formatHotelsList(
        trip: string,
        properties: IProperties,
        quotes: IQuotes
    ): ITripPropertyQuote[] {
        const data: any[] = [];

        for (const quote in quotes) {
            if (quote) {
                data.push({
                    trip,
                    ...properties[quotes[quote].property],
                    ...quotes[quote]
                });
            }
        }

        return data;
    }
}
